import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import style from "./QRViewport.scss";
import { FormattedMessage } from "react-intl";
import { QrDownloadInput } from "../input/QrDownloadInput";
import classNames from "classnames";
import PropTypes from "prop-types";

export function QRViewport({ url, isDesktop, inline, hasDescription }) {
  const [qrCode, setQrCode] = useState(null);

  useEffect(() => {
    let cancelled = false;

    if (!url) {
      setQrCode(null);
      return () => {
        cancelled = true;
      };
    }

    QRCode.toDataURL(url, {
      errorCorrectionLevel: "M",
      margin: 1,
      width: 512
    })
      .then(dataUrl => {
        if (!cancelled) {
          setQrCode(dataUrl);
        }
      })
      .catch(error => {
        if (!cancelled) {
          console.error("Failed to generate room QR code:", error);
          setQrCode(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  const classNameViewport = isDesktop ? style.qrViewportDesktop : style.qrViewportMobile;
  const classShow = inline ? style.inline : "";
  const classDescription = hasDescription ? style.hasDescription : "";

  return (
    <div>
      {qrCode && (
        <div className={classNames(classNameViewport, classShow, classDescription)}>
          <p>
            <FormattedMessage id="room-entry-modal.qr-code" defaultMessage="SCAN TO ACCESS THIS VERSE" />
          </p>
          <img src={qrCode} alt="" />
          {!hasDescription && (
            <QrDownloadInput
              qrCode={qrCode}
              label={<FormattedMessage id="invite-popover.qr-code" defaultMessage="QR Code" />}
            />
          )}
        </div>
      )}
    </div>
  );
}

QRViewport.propTypes = {
  url: PropTypes.string,
  isDesktop: PropTypes.bool,
  inline: PropTypes.bool,
  hasDescription: PropTypes.bool
};
